/**防止重复点击重复弹出message弹框 */
import {
  Message
} from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
  if(document.getElementsByClassName('el-message').length === 0){
    messageInstance = Message(options)
  }
};
/**设置message弹框的格式 */
['error', 'success', 'info', 'warning'].forEach((item) => {
  resetMessage[item] = (msg) => {
    if(document.getElementsByClassName('el-message').length === 0){
      return Message({
        showClose: true,
        duration:2000,
        type: item,
        message: msg
      })
    }
  }
})
export const message = resetMessage
